<template>
  <div>
    <v-sheet class="py-6 py-md-8 px-3" color="primary">
      <TitleWidget :small="xsOnly" dark>
        {{ title }}
      </TitleWidget>
    </v-sheet>

    <v-sheet
      class="pt-6 pt-md-8 pb-10 pb-md-13 pb-lg-16 px-3 mx-auto"
      max-width="600px"
    >
      <ContactForm v-bind="form" />
    </v-sheet>

    <template v-if="informations.map">
      <TitleWidget>Localização</TitleWidget>

      <v-sheet
        color="grey lighten-4 mt-8 mt-md-10 map"
        width="100%"
        v-html="informations.map"
      ></v-sheet>
    </template>
  </div>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import ContactForm from "../components/forms/ContactForm.vue";

const _form = {
  action: "/rest/email/contact-us",
  responseTo: "/fale-conosco/obrigado",
};

const _data = {
  title: "Fale Conosco",
  form: _form,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  components: {
    TitleWidget,
    ContactForm,
  },
};
</script>

<style lang="scss" scoped>
.map::v-deep {
  aspect-ratio: 1.4;
  max-height: 500px;
  min-height: 400px;

  iframe {
    display: block !important;
    height: 100% !important;
    width: 100% !important;
  }
}
</style>
